import { Ability, PureAbility } from '@casl/ability';
import { AbilityModule } from '@casl/angular';
import { GOOGLE_RECAPTCHA_KEY, GOOGLE_MAP_KEY } from '@env';

import { OverlayContainer } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { SnAuthModule } from '@lib/auth';
import { AuthPublicModule } from '@lib/auth/public';
import { SnCoreModule } from '@lib/core';
import { SnFormModule } from '@lib/form';
import { SnFormRecaptchaModule } from '@lib/form/recaptcha';
import { GoogleCoreModule } from '@lib/geo/google/core';
import { GooglePlacesModule } from '@lib/geo/google/places';
import { SnTitleModule } from '@lib/state/title';
import { SnBrandModule } from '@lib/ui/brand';
import { SnDialogModule } from '@lib/ui/dialog';
import { ExistingFullscreenOverlayContainer } from '@lib/ui/overlay';
import { Theme, ThemeModule } from '@lib/ui/theme';

@NgModule({
  imports: [
    // Others
    AbilityModule,
    // Libs
    SnCoreModule,
    SnTitleModule.forRoot(),
    SnFormModule.forRoot(),
    SnFormRecaptchaModule.forRoot(GOOGLE_RECAPTCHA_KEY),
    GoogleCoreModule.forRoot(GOOGLE_MAP_KEY),
    GooglePlacesModule.forRoot(),
    SnDialogModule.forRoot(),
    SnAuthModule.forRoot({
      signUpEnabled: false,
      isVideoMeet: true,
      redirectAuthorizedTo: '/dashboard',
    }),
    AuthPublicModule.forRoot(),
    SnBrandModule.forRoot('Fusus LiveLink', {
      icon: '/assets/logo/icon/white-v2.svg',
      iconInverse: '/assets/logo/icon/white-v2.svg',
      vertical: '/assets/logo/vertical/accent.svg',
      verticalInverse: '/assets/logo/vertical/accent-inverse.svg',
      horizontal: '/assets/logo/horizontal/black-v2.svg',
      horizontalInverse: '/assets/logo/horizontal/white-v2.svg',
    }),
    ThemeModule.forRoot({
      [Theme.Dark]: 'dark-theme.css',
      [Theme.Light]: 'light-theme.css',
    }),
  ],
  providers: [
    { provide: OverlayContainer, useClass: ExistingFullscreenOverlayContainer },
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability },
  ],
})
export class CoreModule {}
